
import AnimatedCard from "./AnimatedCard";
import { GraduationCap, Shield, Wrench } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "./ui/button";

export const AboutSection = () => {
  return <section id="about" className="section-padding relative px-6 overflow-hidden bg-cosmic-gradient">
      {/* Background accents */}
      <div className="absolute top-0 left-0 w-full h-48 bg-gradient-to-b from-[#0c1427] via-[#1a1b3a] to-transparent"></div>
      <div className="absolute bottom-0 left-0 w-full h-48 bg-gradient-to-t from-[#0c1930] via-[#1a1b3a] to-transparent"></div>
      <div className="absolute top-1/4 right-0 w-96 h-96 bg-blue-500/30 rounded-full filter blur-[120px] opacity-20"></div>
      <div className="absolute bottom-1/4 left-0 w-80 h-80 bg-purple-500/30 rounded-full filter blur-[100px] opacity-20"></div>
      
      <div className="bg-grid-pattern absolute inset-0 opacity-30"></div>
      
      <div className="container mx-auto max-w-6xl relative z-10 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">
          {/* Left content - About description */}
          <div className="space-y-8">
            <AnimatedCard animation="fade-in">
              <h2 className="text-3xl md:text-4xl font-bold mb-8">
                <span className="text-gradient text-glow-blue">Boutique Expertise</span>{" "}
                <span className="text-white">for a Changing Legal World</span>
              </h2>
              <p className="text-lg text-white/80 mb-6">
                DocketLabs is an independent consultancy helping small and mid-sized law firms adopt AI the right way — with clarity, security, and practical strategy. We're not vendors, influencers, or theorists. We're real advisors, delivering education, roadmaps, and actionable guidance built for the realities of modern practice.
              </p>
              <p className="text-lg text-white/80 mb-8">
                Our team brings deep technical expertise, a boutique approach, and a relentless focus on safe, ethical AI adoption. Whether you're exploring, scaling, or refining your firm's AI strategy, DocketLabs makes it simple to start smarter and grow stronger.
              </p>
              
              {/* Icons with labels - now with inline layout */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
                <div className="flex items-center gap-3">
                  <div className="p-2 rounded-full bg-blue-500/20 w-10 h-10 flex items-center justify-center">
                    <GraduationCap className="h-5 w-5 text-blue-300" />
                  </div>
                  <span className="text-white/90 text-sm">Education-First Approach</span>
                </div>
                
                <div className="flex items-center gap-3">
                  <div className="p-2 rounded-full bg-blue-500/20 w-10 h-10 flex items-center justify-center">
                    <Shield className="h-5 w-5 text-blue-300" />
                  </div>
                  <span className="text-white/90 text-sm">Built on Security and Trust</span>
                </div>
                
                <div className="flex items-center gap-3">
                  <div className="p-2 rounded-full bg-blue-500/20 w-10 h-10 flex items-center justify-center">
                    <Wrench className="h-5 w-5 text-blue-300" />
                  </div>
                  <span className="text-white/90 text-sm">Practical, Real-World Solutions</span>
                </div>
              </div>
              
              {/* CTA section */}
              <div className="space-y-4">
                <p className="text-white/80">Learn more about who we are — or connect with us today.</p>
                <div className="flex flex-wrap gap-4">
                  <Button variant="outline" asChild className="border-white/20 hover:bg-white/10 text-white">
                    <Link to="/about-us">Learn More</Link>
                  </Button>
                  <Button variant="outline" asChild className="border-white/20 hover:bg-white/10 text-white">
                    <a href="https://www.linkedin.com/company/docketlabs" target="_blank" rel="noopener noreferrer">
                      Connect on LinkedIn
                    </a>
                  </Button>
                </div>
              </div>
            </AnimatedCard>
          </div>

          {/* Right content - Team Photo */}
          <div className="grid grid-cols-1 gap-6 content-center">
            <AnimatedCard delay={200} animation="fade-in">
              <div className="w-full h-auto mb-6 overflow-hidden rounded-2xl cosmic-border glow-purple">
                <img src="/lovable-uploads/optimized/Boutique-1200w.webp" alt="DocketLabs boutique expertise" className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" />
              </div>
            </AnimatedCard>
          </div>
        </div>
      </div>
    </section>;
};

export default AboutSection;
